import Servico from './Servico'

class QuestaoServico extends Servico {
  constructor() {
    super('questao')
  }
}

export default QuestaoServico
